<template>
    <UserMenuAdminPlus v-if="$store.state.adminPlusVersion" v-bind="$props" v-on="$listeners" />
    <UserMenuLegacy v-else v-bind="$props" v-on="$listeners" />
</template>

<script>
import UserMenuLegacy from "./UserMenuLegacy.vue";
import UserMenuAdminPlus from "./UserMenuAdminPlus.vue";

export default {
    name: "UserMenu",
    components: {
        UserMenuLegacy,
        UserMenuAdminPlus,
    },
    props: {
        darkTheme: Boolean,
        appVersion: String,
        stripeAccountId: String,
    },
};
</script>